import {getClient} from '@sentry/browser';

import {isNotNil} from 'ramda';

/**
 * Whether Sentry will actually deliver what it captures — `captureException` returns an event id
 * either way, and linking to an event Sentry never received is worse than linking to nothing.
 */
export const isSentryReporting = (): boolean => {
  const client = getClient();

  return isNotNil(client) && client.getOptions().enabled !== false;
};
